import React, { useContext } from 'react'
import { validateInputField } from '../../Utility/Utility.js'
import SimpleInputField from '../../Custom/CustomInput/SimpleInputField'
import SearchFieldsContext from '../context/context'

const DistanceFilter = () => {

    const { searchFields, setSearchFields } = useContext(SearchFieldsContext)

    function handleChange(e) {
        const { id, value } = e.target
        const i = searchFields.distanceFields.findIndex(x => x.label === id)
        const newSearchFields = searchFields
        const maxInputValue = newSearchFields.distanceFields[i].maxInputValue ? newSearchFields.distanceFields[i].maxInputValue : ''

        const newValue = validateInputField(value, newSearchFields.distanceFields[i].type, maxInputValue)
        newSearchFields.distanceFields[i] = { ...newSearchFields.distanceFields[i], value: newValue }
        setSearchFields({ ...newSearchFields })
        // console.log('searchFields::', searchFields)
    }

    return (
        <>
            <div className="flex flex-col gap-2">
                <div className="text-2">
                    <label>{searchFields.distanceFields[0].label}</label>
                </div>
                <div className="w-full">
                    <SimpleInputField testid={`test-${searchFields.distanceFields[0].label}`} onChange={handleChange} type={searchFields.distanceFields[0].type} placeholder={searchFields.distanceFields[0].placeholder} id={searchFields.distanceFields[0].label} value={searchFields.distanceFields[0].value}></SimpleInputField>
                    {/* <SimpleInputField testid="test-text-Distance" onChange={handleChange} type="number" placeholder="" id="text-Distance" value="5" ></SimpleInputField> */}
                </div>
            </div>
        </>
    )
}

export default DistanceFilter
